// assets
import { DashboardOutlined, ApartmentOutlined, UserOutlined, GiftOutlined, CalendarOutlined, UploadOutlined } from '@ant-design/icons';

// icons
const icons = {
  ApartmentOutlined,
  CalendarOutlined,
  DashboardOutlined,
  GiftOutlined,
  UserOutlined,
  UploadOutlined,
};

// ==============================|| MENU ITEMS - DASHBOARD ||============================== //

const dashboard = {
  id: 'group-dashboard',
  title: 'Navigation',
  type: 'group',
  children: [
    {
      id: 'dashboard',
      title: 'Dashboard',
      type: 'item',
      url: '/dashboard',
      icon: icons.DashboardOutlined,
      breadcrumbs: false
    },
    {
      id: 'category',
      title: 'Category',
      type: 'item',
      url: '/category',
      icon: icons.ApartmentOutlined,
      breadcrumbs: false
    },
    {
      id: 'service',
      title: 'Service',
      type: 'item',
      url: '/service',
      icon: icons.ApartmentOutlined,
      breadcrumbs: false
    },
    {
      id: 'vendor',
      title: 'Vendor',
      type: 'item',
      url: '/vendor',
      icon: icons.UserOutlined,
      breadcrumbs: false
    },
    {
      id: 'coupon',
      title: 'Coupon',
      type: 'item',
      url: '/coupon',
      icon: icons.GiftOutlined,
      breadcrumbs: false
    },
    {
      id: 'booking',
      title: 'Booking',
      type: 'item',
      url: '/booking',
      icon: icons.CalendarOutlined,
      breadcrumbs: false
    }
    ,
    {
      id: 'import',
      title: 'Import',
      type: 'item',
      url: '/import',
      icon: icons.UploadOutlined,
      breadcrumbs: false
    }
  ]
};

export default dashboard;
